export default class Country {
    constructor(public codeIso?: string,
                public label?: string) {
    }
}
